import { booleanToYesNo, formatDateDisplay } from 'Data/format.js'

export let TYPE = {
  BOOLEAN: 0,
  TEXT: 1,
  FAMILY_MEMBER: 2,
  MEDICATION: 3,
  SENSITIVITY: 4,
  NOTIFICATION: 5,
}

let FAMILY_MEMBERS = [
  'MOTHER',
  'FATHER',
  'SISTER',
  'BROTHER',
  'GRANDMOTHER',
  'GRANDFATHER',
  'PARTNER',
  'SPOUSE',
  'STEPMOTHER',
  'STEPFATHER',
  'GUARDIAN',
  'AUNT',
  'UNCLE',
  'CHILD',
  'NEPHEW',
  'NIECE',
  'GRANDSON',
  'GRANDDAUGHTER',
  'STEPCHILD',
  'WARD',
]

export function getType(item) {
  if (item?.note) {
    return TYPE.NOTIFICATION
  }
  let answer = item.answers?.[0]?.value
  switch (item?.category) {
    case 'medications':
      return TYPE.MEDICATION
    case 'drugs_allergies_and_sensitivities':
      return TYPE.SENSITIVITY
    default: {
      if (isFamilyMemberAnswer(answer)) {
        return TYPE.FAMILY_MEMBER
      }

      return TYPE.TEXT
    }
  }
}

export function isFamilyMemberAnswer(answer) {
  if (answer != null) {
    if (Array.isArray(answer)) {
      return answer.every(
        item =>
          typeof item === 'string' &&
          FAMILY_MEMBERS.includes(item.toUpperCase())
      )
    } else if (typeof answer === 'string') {
      return FAMILY_MEMBERS.includes(answer.toUpperCase())
    }
  }

  return false
}

export function getValue({
  response,
  questionType,
  answerAlertValue,
  answerAlert,
}) {
  switch (questionType) {
    case 'boolean':
      return response ? 'Yes' : 'No'
    case 'number':
    case 'choice':
    case 'text':
      return response
    case 'date':
      return formatDateDisplay(response)
    case 'multichoice':
      return Array.isArray(response)
        ? response
            .filter(item => {
              if (answerAlert === false) {
                return false
              }

              if (typeof answerAlertValue === 'boolean') {
                return answerAlertValue
              }

              if (Array.isArray(answerAlertValue)) {
                return answerAlertValue.includes(item)
              }

              return answerAlertValue === item
            })
            .join(', ')
        : response
    default:
      return JSON.stringify(response)
  }
}

export function getAlertValue({
  answer_alert,
  answer_value,
  alert_type,
  alert_conditions,
}) {
  // If the ring bell is on and the value is not a falsy value, the alert must be triggered
  if (
    answer_alert === true &&
    ![false, undefined, null, ''].includes(answer_value)
  ) {
    return true
  }

  // For medical conditions and substances, if a subset of ring bells are enabled,
  //
  if (Array.isArray(answer_alert)) {
    if (Array.isArray(answer_value)) {
      return answer_alert.some(item => answer_value.includes(item))
    }
    return answer_alert.includes(answer_value)
  }

  if (
    answer_alert === false ||
    answer_alert === null ||
    answer_alert === undefined ||
    alert_type === 'none'
  ) {
    return false
  } else if (alert_type === 'any') {
    if (typeof answer_value === 'boolean') {
      return answer_value
    } else if (typeof answer_value === 'string') {
      return !!answer_value.trim().length
    } else if (Array.isArray(answer_value)) {
      return !!answer_value.length
    }
    return true
  } else if (alert_type === 'values') {
    if (Array.isArray(alert_conditions)) {
      if (Array.isArray(answer_value)) {
        return alert_conditions.some(item => answer_value.includes(item))
      }
      return alert_conditions.includes(answer_value)
    }

    return alert_conditions === answer_value
  }

  return false
}

export function getPersonFullName(person) {
  return person
    ? [person.first_name, person.middle_name, person.last_name]
        .filter(Boolean)
        .join(' ')
    : ''
}

export function getTimestamp(date) {
  return date ? new Date(date).getTime() : 0
}
